let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("60cjb")).then(() => parcelRequire('k0E9x'));